import React from "react";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import CircularProgress from "@mui/joy/CircularProgress";
import Divider from "@mui/joy/Divider";
import { AiPlan, AiActionResult } from "../../store/aiStore";
import { ActionItem } from "./ActionItem";

interface PlanConfirmationProps {
  plan: AiPlan;
  results?: AiActionResult[] | null;
  isExecuting: boolean;
  onApprove: () => void;
  onCancel: () => void;
}

export function PlanConfirmation({
  plan,
  results,
  isExecuting,
  onApprove,
  onCancel,
}: PlanConfirmationProps) {
  return (
    <Stack spacing={2}>
      <Typography level="body-md">{plan.summary}</Typography>

      <Divider />

      <Stack spacing={1}>
        {plan.actions.map((action) => {
          const result = results?.find((r) => r.actionId === action.id);
          return <ActionItem key={action.id} action={action} result={result} />;
        })}
      </Stack>

      {!results && (
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            variant="plain"
            color="neutral"
            onClick={onCancel}
            disabled={isExecuting}
            data-testid="command-bar-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="solid"
            color="primary"
            onClick={onApprove}
            disabled={isExecuting}
            startDecorator={isExecuting ? <CircularProgress size="sm" /> : null}
            data-testid="command-bar-approve"
          >
            {isExecuting ? "Executing…" : "Approve"}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
